<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'CommentBaseSubtitle',
  mixins: [baseMixin],
}
</script>

<template>
  <p class="opacity-7 mb-0"> <slot></slot> </p>
</template>
